import * as React from 'react'
import { Select, Space, Typography, Input, Radio, Switch, Tooltip  } from 'antd'
import { CheckOutlined, CloseOutlined, InfoCircleTwoTone } from '@ant-design/icons'
import type { RadioChangeEvent } from 'antd'
import { ExistingNetworks, SecondaryNetworks } from './MainCSoftAccess'
const { Text } = Typography
const { Option } = Select

interface IProps {
  filesIris:            Array<[string, string]>
  existingNetworks:     ExistingNetworks
  setExistingNetworks:  React.Dispatch<React.SetStateAction<ExistingNetworks>>
  secondaryNetworks:    SecondaryNetworks
  setSecondaryNetworks: React.Dispatch<React.SetStateAction<SecondaryNetworks>>
}

export default function CSecondaryNetworks(props: IProps){

  return (
    <div id="conquest-secondary_networks" style={{maxWidth: '1000px'}}>
      {['1','2','3','4','5'].map((idNetwork: string, index: number) => (
        <div key={idNetwork} id={idNetwork} style={{marginBottom: '10px', marginTop: '10px'}}>
          {/* Switch to display or not the fields of the secondary network's informations */}
          <Switch
            id                = {`secondarynetwork${idNetwork}_display`}
            checkedChildren   = {<CheckOutlined />}
            unCheckedChildren = {<CloseOutlined />}
            checked           = {props.secondaryNetworks.secondaryNetworkNotEmpty[index]}
            style             = {{marginRight: '15px'}}
            onChange          = {(checked: boolean) => {
              const updatedNetworkNotEmptyValues  = [...props.secondaryNetworks.secondaryNetworkNotEmpty]
              updatedNetworkNotEmptyValues[index] = checked
              props.setSecondaryNetworks({
                ...props.secondaryNetworks,
                secondaryNetworkNotEmpty: updatedNetworkNotEmptyValues
              })
            }}
          />

          <b style={{fontSize: '17px'}}>Réseau secondaire {idNetwork}</b> 
          {props.secondaryNetworks.secondaryNetworkNotEmpty[index] && (
            <Space style={{width: '100%'}} direction="vertical">
              {/* Select the name of the file_iris of the secondary network */}
              <div className="div-text-input">
                <Text className='text-before-input'>Fichier Iris</Text>
                <Select
                    id               = {`secondary_networks.secondarynetwork${idNetwork}_file_id`}
                    value            = {props.secondaryNetworks.secondary_networks[`secondarynetwork${idNetwork}_file_id`]}
                    style            = {{borderRadius: '4px'}}
                    showSearch
                    optionFilterProp = "label"
                    filterOption     = {(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange         = {(value: string) => {
                      props.setSecondaryNetworks({
                        ...props.secondaryNetworks,
                        secondary_networks: {
                          ...props.secondaryNetworks.secondary_networks,
                          [`secondarynetwork${idNetwork}_file_id`]: value
                        }
                      })
                      props.setExistingNetworks({
                        ...props.existingNetworks,
                        [`network${idNetwork}`]: true
                      })
                    }}
                >
                {props.filesIris.map(([value, label]) => (
                    <Option key={value} value={value} label={label}>
                      {label}
                    </Option>
                ))}
                </Select>
              </div>
              {/* Choose the name of the secondary network as an input text */}
              <div className="div-text-input">
                <Text className='text-before-input'>Nom</Text>
                <Input
                    id       = {`secondary_networks.secondarynetwork${idNetwork}_name`}
                    style    = {{borderRadius: '4px'}}
                    value    = {props.secondaryNetworks.secondary_networks[`secondarynetwork${idNetwork}_name`]}
                    onChange = {(e: any) => {
                      props.setSecondaryNetworks({
                        ...props.secondaryNetworks,
                        secondary_networks: {
                          ...props.secondaryNetworks.secondary_networks,
                          [`secondarynetwork${idNetwork}_name`]: e.target.value
                        }
                      })
                    }}
                />
              </div>
              {/* Select whether or not the secondary network has the same potentiel base as the main network */}
              <div className="div-text-icon-input">
                <Text className='text-before-input'>Même base de potentiel que le réseau principal ?</Text>
                <Tooltip placement="top" title="Si &ldquo;Non&rdquo;, le réseau ne sera pas pris en compte pour le classement du potentiel (pas de numéro), et le réseau ne sera pas modifiable dans Expansion et il sera uniquement possible de voir ce réseau seul (pas de cumulabilité) dans la vue tableau">
                  <InfoCircleTwoTone style={{fontSize: '20px', textAlign: 'left'}}/>
                </Tooltip>
                <Radio.Group
                  id       = {`secondary_networks.secondarynetwork${idNetwork}_potentiel_combinable`}
                  value    = {props.secondaryNetworks.secondary_networks[`secondarynetwork${idNetwork}_potentiel_combinable`]}
                  onChange = {(e: RadioChangeEvent) => {
                    props.setSecondaryNetworks({
                      ...props.secondaryNetworks,
                      secondary_networks: {
                        ...props.secondaryNetworks.secondary_networks,
                        [`secondarynetwork${idNetwork}_potentiel_combinable`]: e.target.value
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>
              {/* Select whether or not the secondary network can be viewed on the map with the main network */}
              <div className="div-text-icon-input">
                <Text className='text-before-input'>Combinable avec le réseau principal en vue carte ?</Text>
                <Tooltip placement="top" title="Si &ldquo;Non&rdquo;, le réseau ne pourra pas être affiché en même temps que d'autres réseaux sur la vue carte">
                  <InfoCircleTwoTone style={{fontSize: '20px', textAlign: 'left'}}/>
                </Tooltip>
                <Radio.Group
                  id       = {`secondary_networks.secondarynetwork${idNetwork}_map_combinable`}
                  value    = {props.secondaryNetworks.secondary_networks[`secondarynetwork${idNetwork}_map_combinable`]}
                  onChange = {(e: RadioChangeEvent) => {
                    props.setSecondaryNetworks({
                      ...props.secondaryNetworks,
                      secondary_networks: {
                        ...props.secondaryNetworks.secondary_networks,
                        [`secondarynetwork${idNetwork}_map_combinable`]: e.target.value
                      }
                    })
                  }}
                >
                  <Radio value={true}>Oui</Radio>
                  <Radio value={false}>Non</Radio>
                </Radio.Group>
              </div>
            </Space>
          )}
        </div>
      ))}
    </div>
  )
}
